// Local Variables
const isInMobileApp = typeof window !== 'undefined' && window.nativeBabbelApp !== undefined;

// Module Exports
export { isInMobileApp };
